import React from 'react'

export const CompactCtaContext = React.createContext<boolean>(false)
